import * as React from "react";
import {CSSProperties} from "react";
import {Icon} from "antd";
import locales from "../locales";
import {Link} from "react-router-dom";

interface Props {
  name: string;
  link: string;
  warning: boolean;
}

class ClientName extends React.Component<Props> {

  public render(): React.ReactNode {
    const {name, link, warning} = this.props;
    const iconStyle: CSSProperties = {
      fontSize: 16,
      color: 'var(--color-yellow)'
    };
    return (
      <Link to={link}>
        {name}
        {warning && (
          <span>
                        &nbsp;
            &nbsp;
            <Icon type="warning"
                  theme="filled"
                  style={iconStyle}
                  title={locales.warning}/>
                    </span>
        )}
      </Link>
    );
  }
}

export default ClientName;


// WEBPACK FOOTER //
// ./src/common/ClientName.tsx